import { render, staticRenderFns } from "./MedellinFooter.vue?vue&type=template&id=38f321c6&scoped=true&"
import script from "./MedellinFooter.vue?vue&type=script&lang=ts&"
export * from "./MedellinFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MedellinFooter.vue?vue&type=style&index=0&id=38f321c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f321c6",
  null
  
)

export default component.exports